import { useState, useEffect } from "react";
import * as React from "react";
const defaultIntervalDelay = 3000; // 3 seconds
/**
 * Component that rotates throug "maxDots" dots.
 * For example, if maxDots is 3, the component will render: ".", "..", "..." and then start over.
 */ export const BeanCounter = (props)=>{
    const { maxDots, intervalDelay } = props;
    const [currentNumber, setcurrentNumber] = useState(0);
    const delay = intervalDelay ?? defaultIntervalDelay;
    useEffect(()=>{
        const interval = setInterval(()=>{
            setcurrentNumber((prevNumber)=>(prevNumber + 1) % maxDots);
        }, delay);
        return ()=>clearInterval(interval);
    }, [
        maxDots,
        delay
    ]);
    if (maxDots < 0) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/ React.createElement("div", null, ".".repeat(currentNumber + 1));
};
